import App_EULA from '../../assets/pdf/App_EULA.pdf'
import PDFViewer from '../../shared/PDFViewer';



function Eula(props:any) {
    return <PDFViewer pdf={App_EULA} />;
}

export default Eula;